export const appId = '53nft1CdER9qxf87isGT';
export const appCode = 'UVAvdYYqxGLh9fUajGDV9w';
export const languageMap = {
  en: 'eng',
  es: 'spa'
};
export const defaultLanguage = 'en';

export const getHereLangCode = lang => languageMap[lang] || languageMap[defaultLanguage];
